export default __webpack_public_path__ + "static/media/About2.0386db03.jpg";